import { ausschnitt } from './ton.js';
export function pausen(welle, vonSek, bisSek, { schwelle = 0.015, mindestens = 0.6, luft = 0.12 } = {}) {
    const teil = ausschnitt(welle, vonSek, bisSek);
    if (teil.length < 2)
        return [];
    const sekundeProEimer = (bisSek - vonSek) / teil.length;
    const runde = (v) => Math.round(v * 100) / 100;
    const raus = [];
    let anfang = -1;
    for (let i = 0; i <= teil.length; i++) {
        const still = i < teil.length && teil[i] < schwelle;
        if (still && anfang < 0)
            anfang = i;
        if (!still && anfang >= 0) {
            // Eine Strecke am Rand ist keine Pause, sondern Stille vorn oder hinten.
            if (anfang > 0 && i < teil.length) {
                const von = vonSek + anfang * sekundeProEimer + luft;
                const bis = vonSek + i * sekundeProEimer - luft;
                if (bis - von >= mindestens)
                    raus.push({ von: runde(von), bis: runde(bis) });
            }
            anfang = -1;
        }
    }
    return raus;
}
/**
 * Was vom Clip bleibt, wenn die Pausen wegfallen: die Stücke dazwischen,
 * lückenlos hintereinander ab `clip.start`. Was danach auf der Spur liegt,
 * rückt nicht nach -- das ist eine eigene Entscheidung (S1, Ripple).
 *
 * `speed` steht dazwischen wie bei `nachStilleSchnitt`: die Pausen zählen in
 * der Zeit der Datei, `start` und `duration` in der des Schnitts. Stücke
 * unter `mindestens` Sekunden fallen weg -- ein Zehntel Ton zwischen zwei
 * Pausen ist kein Satz.
 */
export function ohnePausen(clip, liste, mindestens = 0.1) {
    const tempo = clip.speed > 0 ? clip.speed : 1;
    const ende = clip.sourceIn + clip.duration * tempo;
    const sortiert = [...liste].filter((p) => p.bis > p.von).sort((a, b) => a.von - b.von);
    const stuecke = [];
    let zeiger = clip.sourceIn;
    let start = clip.start;
    const lege = (von, bis) => {
        const dauer = (bis - von) / tempo;
        if (dauer < mindestens)
            return;
        const r = (v) => Math.round(v * 1000) / 1000;
        stuecke.push({ start: r(start), duration: r(dauer), sourceIn: r(von) });
        start += dauer;
    };
    for (const p of sortiert) {
        const von = Math.max(zeiger, p.von);
        const bis = Math.min(ende, p.bis);
        if (bis <= von)
            continue;
        lege(zeiger, von);
        zeiger = bis;
    }
    lege(zeiger, ende);
    return stuecke;
}
//# sourceMappingURL=pausen.js.map